import { Badge, Tooltip } from "@mui/material";
import RuleIcon from "@mui/icons-material/Rule";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getApprovalStatsAction } from "../../Actions/ApprovalActions";
import { getUserData } from "../../Actions/common";
import { useNotification } from "../Notification/NotificationProvider";


const ApprovalBell = () => {
  const [pendingCount, setPendingCount] = useState(0);
  const [prevNotifCount, setPrevNotifCount] = useState(0);
  const navigate = useNavigate();
  const { notifications } = useNotification();

  const userData = localStorage.getItem("userData") ? getUserData() : null;
  const isAdmin =
    userData?.role?.isAdmin === true ||
    userData?.role?.isAdmin === 1 ||
    userData?.isAdmin === true ||
    userData?.isAdmin === 1;

  useEffect(() => {
    if (!isAdmin) return;
    getApprovalStatsAction()
      .then((res) => {
        const count = res?.data?.data?.pending ?? 0;
        setPendingCount(count);
      })
      .catch(() => { });
  }, [isAdmin]);

 
  useEffect(() => {
    if (!isAdmin) return;
    const unreadApprovalNotifs = notifications.filter(
      (n) =>
        !n.isRead &&
        typeof n.message === "string" &&
        (n.message.toLowerCase().includes("request submitted for") ||
          n.message.toLowerCase().includes("approval"))
    );
    const currentCount = unreadApprovalNotifs.length;
    if (currentCount !== prevNotifCount) {
      getApprovalStatsAction()
        .then((res) => {
          setPendingCount(res?.data?.data?.pending ?? 0);
        })
        .catch(() => { });
      setPrevNotifCount(currentCount);
    }
  }, [notifications, isAdmin, prevNotifCount]);

  if (!isAdmin) return null;

  return (
    <Tooltip title="Approval Requests" placement="bottom" arrow>
      <Badge
        badgeContent={pendingCount > 0 ? pendingCount : null}
        onClick={() => navigate("/approvals")}
        sx={{
          cursor: "pointer",
          "& .MuiBadge-badge": {
            background: "#f59e0b",
            color: "#fff",
            top: "4px",
            right: "4px",
            fontWeight: 700,
            fontSize: "11px",
            minWidth: "18px",
            height: "18px",
          },
        }}
      >
        <div
          className="btn btn-icon rounded-circle bg-white position-relative w-40px h-40px w-xl-50px h-xl-50px"
          style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <RuleIcon sx={{ fontSize: 22, color: "#22419e" }} />
        </div>
      </Badge>
    </Tooltip>
  );
};

export default ApprovalBell;
